export const types = {
  SELECT: 'SELECT/SELECTPRODUCT',
};

export const initialState = {
  select: null,
};

const Select = (state = initialState, action) => {
  switch (action.type) {
    case types.SELECT:
      return JSON.parse(
        JSON.stringify({
          ...state,
          data: action.payload,
        })
      );
    default:
      return { ...state };
  }
};

export const actions = {
  select: data => ({ type: types.SELECT, payload: data }),
};

export default Select;
